import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import auth from "../../firebaseConfig";
import fetchIntercept from "fetch-intercept";
import { API_URL } from "../../config";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loginDoctorDetails, setLoginDoctorDetails] = useState(null);
  const [globalLoading, setGlobalLoading] = useState(false);

  useEffect(() => {
    const unregister = fetchIntercept.register({
      request: (url, config) => {
        if (config?.headers) {
          const header = new Headers(config.headers);
          config.headers = header;
        }
        setGlobalLoading(true);
        return [url, config];
      },
      response: (response) => {
        setGlobalLoading(false);
        return response;
      },
      responseError: (error) => {
        setGlobalLoading(false);
        return Promise.reject(error);
      },
    });

    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        const token = await currentUser.getIdToken();
        setUser({ auth: currentUser, token });

        const response = await fetch(`${API_URL}/auth/portal`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          setLoginDoctorDetails(data);
        }
      } else {
        setUser(null);
        setLoginDoctorDetails(null);
      }
      setLoading(false);
    });

    return () => {
      unsubscribe();
      unregister();
    };
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        loginDoctorDetails,
        setUser,
        setLoginDoctorDetails,
        globalLoading,
        setGlobalLoading,
      }}
    >
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
